<template>
  <div class="backgroud-white cs-courseSchedule-editor" v-loading="isLoadingData">
    <div class="backgroud-gray-popup popup-content-area-small">
      <el-row class="refund-detail-area">
        <el-col :span="4">
          <span>课程名称：</span>
        </el-col>
        <el-col :span="6">
          <span>{{refundDetailModel.CourseName}}</span>
        </el-col>
      </el-row>
      <el-row class="refund-detail-area">
        <el-col :span="4">
          <span>实收价格：</span>
        </el-col>
        <el-col :span="6">
          <span>{{refundDetailModel.PaymentDiscountPrice | toCurrency}}</span>
        </el-col>
      </el-row>
      <el-row class="refund-detail-area">
        <el-col :span="3">
          <span>支付方式：</span>
        </el-col>
        <el-col :span="5">
          <div>现金/转帐</div>
          <div>{{refundDetailModel.IncomeInFact| toCurrency}}</div>
        </el-col>
        <el-col :span="5">
          <div>旧余额</div>
          <div>{{refundDetailModel.OldBalanceCost| toCurrency}}</div>
        </el-col>
        <el-col :span="5">
          <div>新余额</div>
          <div>{{refundDetailModel.NewBalanceCost| toCurrency}}</div>
        </el-col>
        <el-col :span="5">
          <div>赠送余额</div>
          <div>{{refundDetailModel.GiftBalanceCost| toCurrency}}</div>
        </el-col>
      </el-row>
      <el-row class="refund-detail-area margin-top-10">
        <el-col :span="3">
          &nbsp;
        </el-col>
        <el-col :span="5">
          <div>积分</div>
          <div>{{refundDetailModel.BonusPointCost}}</div>
        </el-col>
        <el-col :span="5">
          <div>代金券</div>
          <div>{{refundDetailModel.CashDecreasedAmount| toCurrency}}</div>
        </el-col>
      </el-row>
      <!-- <el-row class="refund-detail-area">
        <el-col :span="4">
          <span>退款单价：</span>
        </el-col>
        <el-col :span="6">
          <span>{{refundDetailModel.RefundPrice}}</span>
        </el-col>
      </el-row> -->
      <el-row class="refund-detail-area">
        <el-col :span="4">
          <span>退款方式：</span>
        </el-col>
        <el-col :span="6">
          <span>退余额</span>
        </el-col>
      </el-row>
      <!-- <el-form ref="refundResult" :model="refundResult.RefundHistory" :rules="rules">
        <el-form-item prop="RefundStatus" label="退款方式：" label-width="100px" required>
          <el-select v-model="refundResult.RefundHistory.RefundStatus" placeholder="请选择" size="mini">
            <el-option v-for="item in refundTypeList" :key="item.Id" :label="item.Name" :value="item.Id">
            </el-option>
          </el-select> 
          <span>退余额</span>
        </el-form-item>
      </el-form>-->
      <el-row v-show="refundResult.RefundHistory.RefundStatus == 1" class="refund-detail-area">
        <el-col :span="4">
          <span>&nbsp; </span>
        </el-col>
        <el-col :span="21">
          <span v-if="refundDetailModel.DecreaseDebt != 0">减欠款 {{(refundDetailModel.DecreaseDebt) | toCurrency}},</span>
          <span v-if="refundDetailModel.CashDecreasedAmount != 0">减现金减 {{(refundDetailModel.CashDecreasedAmount) | toCurrency}},</span>
          <span v-if="bonusPointIncrease != 0">退还积分：{{bonusPointIncrease}}({{bonusPointIncreaseAmount | toCurrency}}), </span>
          <span v-if="bonusPointDescrease != 0">扣除积分：-{{bonusPointDescrease}}</span>

          <br />

          <span>退还旧余额：{{refundResult.RefundHistory.RefundOldBalance + refundResult.RefundHistory.RefundOldBalanceTax | toCurrency}}<span
              v-if="refundResult.RefundHistory.RefundOldBalanceTax > 0">(含退税 {{refundResult.RefundHistory.RefundOldBalanceTax| toCurrency}})</span>,</span>
          <span>退还新余额：{{refundResult.RefundHistory.RefundNewBalance + refundResult.RefundHistory.RefundNewBalanceTax | toCurrency}}<span
              v-if="refundResult.RefundHistory.RefundNewBalanceTax > 0">(含退税 {{refundResult.RefundHistory.RefundNewBalanceTax| toCurrency}})</span>,</span>
          <span>退还赠送余额：{{refundResult.RefundHistory.RefundGiftBalance + refundResult.RefundHistory.RefundGiftBalanceTax | toCurrency}}<span
              v-if="refundResult.RefundHistory.RefundGiftBalanceTax > 0">(含退税 {{refundResult.RefundHistory.RefundGiftBalanceTax| toCurrency}})</span></span>
          <span v-if="bonusPointDescreaseNotEnough != 0">(扣除积分-{{bonusPointDescreaseNotEnough}},
            对应金额：-{{bonusPointDescreaseNotEnoughPrice | toCurrency}})</span>

        </el-col>
      </el-row>
    </div>
    <div slot="footer" class="dialog-footer popup-footer">
      <el-row>
        <el-col :span="20" :xs="16" class="footer-left">
          <span v-if="!showError"></span>
          <el-alert :closable="false" v-if="showError" v-bind:title="errorMessage" type="error" show-icon></el-alert>
        </el-col>
        <el-col class="footer-right" :span="4" :xs="8">
          <el-button :loading="loading" type="primary"
            @click="save()">确认退款</el-button>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.refund-detail-area {
  padding-left: 18px;
}
</style>

<script>
import { getOtherCollectFeeRefundDetail, saveOtherCollectFeeRefund } from "../../service/finance.service.js";
import { getBonusPointMechanismListByTypes } from "../../service/bonusPoint.service";
import { toDecimal } from "../../config/mUtils";

export default {
  props: {
    dataIn: {
      workflowId: Number
    },
  },
  data() {
    return {
      bonusPointIncrease: 0,
      bonusPointIncreaseAmount: 0,
      bonusPointDescrease: 0,
      bonusPointDescreaseNotEnough: 0, //不足积分
      bonusPointDescreaseNotEnoughPrice: 0, //积分不足扣除金额
      moneyToBonusPoint: {},
      bonusPointToMoney: {},
      refundDetailModel: {},
      refundResult: {
        RefundHistory: {
          RefundStatus: 1,
        },
      },
      showError: false,
      loading: false,
      isLoadingData: false,
      disabledSaveButton: false,
      errorMessage: "",
      refundTypeList: [
        {
          Id: 1,
          Name: "退余额",
        },
        // {
        //   Id: 2,
        //   Name: "退现金",
        // },
      ],
      rules: {},
    };
  },
  created() {
    getBonusPointMechanismListByTypes([1, 2]).then((result) => {
      if (result && result.success) {
        let mechanismItem = result.data.find(item => item.MechanismType === 1);
        if (!!mechanismItem)
          this.moneyToBonusPoint = mechanismItem;
        mechanismItem = result.data.find(item => item.MechanismType === 2);
        if (!!mechanismItem)
          this.bonusPointToMoney = mechanismItem;
        this.loadRefundDetail();
      }
    });
  },
  methods: {
    loadRefundDetail() {
      if (
        Object.keys(this.moneyToBonusPoint).length > 0 &&
        Object.keys(this.bonusPointToMoney).length > 0
      ) {
        this.refundResult.WorkflowId = this.dataIn.workflowId;
        if (
          this.dataIn &&
          this.dataIn.workflowId > 0
        ) {
          this.isLoadingData = true;
          getOtherCollectFeeRefundDetail(
            this.dataIn.workflowId
          ).then((result) => {
            if (result && result.success) {
              this.refundDetailModel = result.data;
              this.calculateRefund();
              this.refundResult.RefundHistory.PayDebt =
                this.refundDetailModel.DecreaseDebt;
              if (!!result.data.RefundHistory) {
                this.refundResult.RefundHistory = result.data.RefundHistory;
              }

              this.refundResult.RefundHistory.RefundStatus = 1;
            } else {
              if (!!result.message) {
                this.$message({
                  message: result.message,
                  type: "error",
                });
              }
            }
            this.isLoadingData = false;
          });
        }
      }
    },
    save() {
      if (!this.refundResult.RefundHistory.RefundStatus) {
        this.$message({
          message: "请选择退款方式",
          type: "warning",
        });
        return;
      }

      if (!!this.refundDetailModel.Debt) {
        this.$message({
          message: "有欠款的账目暂不允许退款",
          type: "warning",
        });
        return;
      }

      let self = this;
      this.loading = true;
      this.$confirm("您确认要按此退款方案进行退款吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          self.refundResult.WorkflowId = self.dataIn.workflowId;
          self.refundResult.OriginalRefundDetail = self.refundDetailModel;
          self.refundResult.StudentId = self.refundDetailModel.StudentId;

          if (
            self.refundResult.RefundHistory.PayDebt == 0 &&
            self.refundDetailModel.DecreaseDebt > 0
          ) {
            self.refundResult.RefundHistory.PayDebt =
              self.refundDetailModel.DecreaseDebt;
          }
          saveOtherCollectFeeRefund(self.refundResult).then((result) => {
            if (result && result.success) {
              this.$message({
                message: "退款成功",
                type: "success",
              });
              self.reset();
              self.$emit("closeRefundEditor", "success");
            } else {
              self.showError = true;
              self.errorMessage = result.message;
            }
            self.loading = false;
          });
        })
        .catch(() => {
          self.loading = false;
        });
    },
    calculateRefund() {
      //1.初始计算
      this.refundResult.LeftMoney = this.refundDetailModel.PaymentDiscountPrice - this.refundDetailModel.RefundPrice;
      if (this.refundResult.LeftMoney < 0){
          this.refundResult.LeftMoney = 0;
      }
      this.refundResult.RefundHistory.RefundBalance = 0;
      this.refundResult.RefundHistory.RefundOldBalance = 0;
      this.refundResult.RefundHistory.RefundNewBalance = 0;
      this.refundResult.RefundHistory.RefundGiftBalance = this.refundDetailModel.GiftBalanceCost;


      this.refundResult.RefundHistory.RefundBonusPointDecreased = 0;

      this.bonusPointIncrease = 0;
      this.bonusPointDescrease = 0;
      this.bonusPointDescreaseNotEnough = 0;
      this.bonusPointDescreaseNotEnoughPrice = 0;
      let afterCashDecrease = this.refundResult.LeftMoney - this.refundDetailModel.CashDecreasedAmount - this.refundDetailModel.GiftBalanceCost;
      //2.减去现金减后，节余金额。如果<=0，那么无钱可退；如果>0，那么开始处理积分
      if (afterCashDecrease <= 0) {
          this.refundResult.RefundHistory.RefundBonusPoint = 0;
          this.refundResult.RefundHistory.RefundBalance = 0;
          this.refundResult.RefundHistory.RefundGiftBalance = this.refundResult.LeftMoney - this.refundDetailModel.CashDecreasedAmount;
      } else {
          //3.减去积分抵扣后，节余金额。如果<=0，那么说明积分可以抵扣完节余金额，则退还节余金额对应的积分；如果>0，那么退还所有积分，且开始处理余额
          let afterBonusPointDecrease = afterCashDecrease - this.refundDetailModel.BonusPointAmount;
          if (afterBonusPointDecrease <= 0) {
              this.refundResult.RefundHistory.RefundBonusPoint = Math.round(this.refundDetailModel.BonusPointCost * (afterCashDecrease / this.refundDetailModel.BonusPointAmount));
              this.refundResult.RefundHistory.RefundBalance = 0;
              this.bonusPointIncrease =  this.refundResult.RefundHistory.RefundBonusPoint;
              this.bonusPointIncreaseAmount = this.getBonusPointAmount(this.bonusPointIncrease);
              this.bonusPointDescrease = 0;
          } else {
              this.refundResult.RefundHistory.RefundBonusPoint = this.refundDetailModel.BonusPointCost;
              this.bonusPointIncrease =  this.refundResult.RefundHistory.RefundBonusPoint;
              this.bonusPointIncreaseAmount = this.getBonusPointAmount(this.bonusPointIncrease);
              this.bonusPointDescrease = 0;
              //4.实付金额=现金/转帐+余额支付, 如果实付金额<=节余金额,那么最多只能退实付金额到余额；否则退节余金额到余额。
              let paidSum = this.refundDetailModel.IncomeInFact + this.refundDetailModel.BalanceCost;
              if (paidSum > 0){
                  this.refundResult.RefundHistory.RefundBalance = paidSum <= afterBonusPointDecrease ? paidSum : afterBonusPointDecrease;
                  //5.如果要退余额，计算应退的新余额和旧余额
                  if (this.refundDetailModel.OldBalanceCost >= this.refundResult.RefundHistory.RefundBalance){
                      this.refundResult.RefundHistory.RefundNewBalance = 0;
                      this.refundResult.RefundHistory.RefundOldBalance = this.refundResult.RefundHistory.RefundBalance;
                  }else{
                      this.refundResult.RefundHistory.RefundOldBalance = this.refundDetailModel.OldBalanceCost;
                      this.refundResult.RefundHistory.RefundNewBalance = this.refundResult.RefundHistory.RefundBalance - this.refundResult.RefundHistory.RefundOldBalance;
                  }
              }
              else{
                  this.refundResult.RefundHistory.RefundBalance = 0;
              }
          }
      }

      this.refundResult.RefundHistory.RefundOldBalanceTax = 0;
      this.refundResult.RefundHistory.RefundNewBalanceTax = 0;
      this.refundResult.RefundHistory.RefundGiftBalanceTax = 0;
    },
    reset() {
      this.showError = false;
      this.errorMessage = "";
      this.refundResult.RefundHistory.RefundStatus = "";
      //this.$refs["refundResult"].resetFields();
    },
    getBonusPointAmount(value) {
      return toDecimal(
        (value * this.bonusPointToMoney.Money) /
          this.bonusPointToMoney.BonusPoint
      );
    },
  },
  watch: {
    dataIn: function () {
      this.loadRefundDetail();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/common/otherCollectFeeRefundEditor.vue